/* eslint camelcase: 0 */
import moment from 'moment'
import { News } from '@/infrastructure/network/Upstream/schema'
import { INewsProps, EmptyNewsPropsFactory } from '@/entities/Upstream/News'

export const toNewsProps = (props: News | null | undefined): INewsProps => {
  if (!props) {
    return EmptyNewsPropsFactory()
  }

  const { id, views, category, published_at, created_at, updated_at } = props
  const title = props.title ? JSON.parse(props.title).title : EmptyNewsPropsFactory().title
  const description = props.description ? JSON.parse(props.description).description : EmptyNewsPropsFactory().description
  const properties = props.properties ? JSON.parse(props.properties).properties : EmptyNewsPropsFactory().properties

  return EmptyNewsPropsFactory({
    id,
    title,
    description,
    views,
    category,
    properties,
    likes: 0,
    publishedAt: published_at ? moment(published_at).format('YYYY-MM-DD HH:mm:ss') : null,
    createdAt: created_at ? moment(created_at).format('YYYY-MM-DD HH:mm:ss') : null,
    updatedAt: updated_at ? moment(updated_at).format('YYYY-MM-DD HH:mm:ss') : null
  })
}
